import React, { useEffect, useState } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
    CartesianGrid
} from 'recharts';

// Tạo dữ liệu giả lập 10 đường + 1 đường trung bình
const NUM_CURVES = 10;
const NUM_POINTS = 100;
const BASE = 50000;

const colors = [
    '#1E40AF', '#67E8F9', '#A21CAF', '#7C3AED', '#F59E42',
    '#F43F5E', '#22D3EE', '#FBBF24', '#6366F1', '#EF4444'
];

const data = Array.from({ length: NUM_POINTS }, (_, i) => {
    const point: any = { trade: i + 1 };
    let sum = 0;
    for (let c = 0; c < NUM_CURVES; c++) {
        // Tạo dữ liệu random kiểu equity curve
        const val = BASE + Math.round(Math.sin(i / (5 + c)) * 2000 + Math.random() * 2000 - 1000);
        point[`curve${c + 1}`] = val;
        sum += val;
    }
    point.avg = Math.round(sum / NUM_CURVES);
    return point;
});

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div style={{ background: '#fff', border: '1px solid #ccc', padding: 12, minWidth: 180 }}>
                <div style={{ fontWeight: 600, marginBottom: 6 }}>Number of trades: {label}</div>
                {payload
                    .filter((entry: any) => entry.dataKey !== 'avg_equity')
                    .map((entry: any, idx: number) => (
                        <div key={entry.dataKey} style={{ color: entry.stroke, fontWeight: 500 }}>
                            Curve {idx + 1}: ${entry.value.toLocaleString()}
                        </div>
                    ))}
                <div style={{ color: '#000', fontWeight: 700, marginTop: 4 }}>
                    Average: ${payload.find((e: any) => e.dataKey === "avg_equity")?.value.toLocaleString()}
                </div>
            </div>
        );
    }
    return null;
};


interface equityCurvesProps {
    avg_equity: number
    line1: number
    line2: number
    line3: number
    line4: number
    line5: number
    line6: number
    line7: number
    line8: number
    line9: number
    line10: number
    trade: number
}

type TradingChartProps = {
  equityCurves: equityCurvesProps[];
  avgDataTable: {
        avg_drawdown_percent: number
        max_consecutive_losers: number
        max_consecutive_winners: number
        max_drawdown_percent: number
        max_equity: number
        min_equity: number
    }
};

const TradingChart = ({equityCurves, avgDataTable}: TradingChartProps) => {

    const [betweenMinMax, setBetweenMinMax] = useState<number[]>()
    const elementQuity = equityCurves[0]
    const totaElementQuity = Object.keys(elementQuity).length

    const handleDistanceBetweenChart = () => {
        const filData = []
        for(let i = 0; i < 10; i++) {
            const data = avgDataTable.max_equity / 10 * i
            const handledData = Number(data.toFixed(2))
            filData.push(handledData)
        }

        setBetweenMinMax(filData)
    }

    useEffect(() => {
        handleDistanceBetweenChart()
        console.log(equityCurves)
    }, [])

    return(
        <ResponsiveContainer width="100%" height={350}>
            <LineChart
                data={equityCurves}
                margin={{ top: 0, right: 0, left: 30, bottom: 30 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey="trade"
                    type="number"
                    domain={[0, equityCurves.length]}
                    ticks={[0, 20, 40, 60, 80, 100]}
                    tick={{ fontSize: 14 }}
                    tickLine={false}
                    axisLine={false}
                    label={{
                        value: 'Number of trades',
                        position: 'insideBottom',
                        offset: -5,
                        fontWeight: 300,
                        fontSize: 12,
                        dy: 0,
                        color: '#c6c6c6'
                    }}
                />
                {betweenMinMax && <YAxis
                    domain={[avgDataTable.min_equity, avgDataTable.max_equity]}
                    ticks={betweenMinMax}
                    tickFormatter={val => `$${val.toLocaleString()}`}
                    tick={{ fontSize: 14 }}
                    tickLine={false}
                    tickMargin={totaElementQuity} // Đẩy số vào trong, tăng giá trị nếu muốn cách xa hơn
                    axisLine={false}
                    label={{
                        value: 'Balance',
                        angle: -90,
                        position: 'insideLeft',
                        fontWeight: 300,
                        fontSize: 12,
                        dy: 30,
                        dx: -30,
                        color: '#c6c6c6'
                    }}
                />}
                <Tooltip content={<CustomTooltip />} />
                {/* 10 đường mô phỏng */}
                {Array.from({ length: NUM_CURVES }).map((_, idx) => (
                    <Line
                        key={`line_${idx + 1}`}
                        type="linear"
                        dataKey={`line_${idx + 1}`}
                        stroke={colors[idx]}
                        strokeWidth={1}
                        dot={false} // Ẩn chấm mặc định
                        activeDot={{ r: 4 }} // Chỉ hiện chấm khi hover
                        isAnimationActive={false}
                    />
                ))}
                {/* Đường trung bình màu đen, đậm */}
                <Line
                    type="linear"
                    dataKey="avg_equity"
                    stroke="#000"
                    strokeWidth={5}
                    dot={false}
                    isAnimationActive={false}
                />
            </LineChart>
        </ResponsiveContainer>
    )
};

export default TradingChart;